module.exports = __webpack_public_path__ + "static/media/logo.3498254b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/logos/firstinsight/logo.png
// module id = 966
// module chunks = 0